(function () {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var FlickityImageGallery = function FlickityImageGallery(element) {
    var _this = this;

    _classCallCheck(this, FlickityImageGallery);

    _defineProperty(this, "initialize", function () {
      _this.element.classList.add('FlickityImageGallery');

      _this.flickity = new Flickity(_this.element, {
        prevNextButtons: true,
        arrowShape: {
          x0: 20,
          x1: 60,
          y1: 40,
          x2: 60,
          y2: 35,
          x3: 25
        },
        pageDots: false,
        wrapAround: true,
        dragThreshold: 8,
        adaptiveHeight: true
      });

      _this.appendFullScreenButtons();

      window.addEventListener('load', function () {
        _this.flickity.resize();
      });
    });

    _defineProperty(this, "appendFullScreenButtons", function () {
      _this.appendFullScreenButton('view');

      _this.appendFullScreenButton('exit');
    });

    _defineProperty(this, "appendFullScreenButton", function (modifierClass) {
      var button = document.createElement('button');
      button.className = "RoundButton flickity-fullscreen-button ".concat(modifierClass);

      _this.flickity.element.appendChild(button);

      button.addEventListener('click', _this.toggleFullScreen);
    });

    _defineProperty(this, "toggleFullScreen", function () {
      _this.flickity.element.classList.toggle('is-fullscreen');

      document.documentElement.classList.toggle('is-flickity-fullscreen');

      _this.flickity.resize();

      _this.isFullscreen = !_this.isFullscreen;

      if (_this.isFullscreen) {
        document.addEventListener('keydown', _this.onKeydown);
      }
    });

    _defineProperty(this, "onKeydown", function (event) {
      if (event.key === 'Escape' && _this.isFullscreen) {
        _this.toggleFullScreen();

        document.removeEventListener('keydown', _this.onKeydown);
      }
    });

    this.element = element;
    this.isFullscreen = false;
    this.initialize();
  };

  var AgeModal = function AgeModal() {
    var _this = this;

    _classCallCheck(this, AgeModal);

    _defineProperty(this, "init", function () {
      _this.isOpen = false;
      _this.localStorageKey = "".concat(location.origin, "__age-modal");
      _this.modal = document.querySelector('#age-modal');
      _this.overlay = document.querySelector('.PageOverlay');

      if (_this.modal) {
        _this.confirmButton = _this.modal.querySelector('[data-action="close-modal"]');
        _this.denyButton = _this.modal.querySelector('[data-action="show-message"]');
        _this.toggleElements = _this.modal.querySelectorAll('[data-toggle-visibility]');
      }

      var closedAt = localStorage.getItem(_this.localStorageKey);
      var daysPassed = Math.floor((Date.now() - closedAt) / 1000 / 60 / 60 / 24);
      var daysToShowAgain = 365 / 2;
      var shouldShowModal = !closedAt || daysPassed > daysToShowAgain;
      var domElementsArePresent = !!(_this.modal && _this.overlay && _this.confirmButton && _this.denyButton && _this.toggleElements.length);

      if (domElementsArePresent && shouldShowModal) {
        _this.showModal();

        _this.confirmButton.addEventListener('click', _this.onConfirmButtonClick);

        _this.denyButton.addEventListener('click', _this.onDenyButtonClick);
      }
    });

    _defineProperty(this, "showModal", function () {
      _this.isOpen = true;

      _this.modal.setAttribute('aria-hidden', 'false');

      _this.overlay.classList.add('is-visible');

      document.documentElement.classList.add('no-scroll');
    });

    _defineProperty(this, "hideModal", function () {
      _this.isOpen = false;

      _this.modal.setAttribute('aria-hidden', 'true');

      _this.overlay.classList.remove('is-visible');

      document.documentElement.classList.remove('no-scroll');
    });

    _defineProperty(this, "onConfirmButtonClick", function () {
      _this.hideModal();

      localStorage.setItem(_this.localStorageKey, Date.now());

      _this.onClose();
    });

    _defineProperty(this, "onDenyButtonClick", function () {
      _this.toggleElements.forEach(function (element) {
        var currentDisplay = element.style.display;
        element.style.display = currentDisplay === 'none' ? null : 'none';
      });
    });

    _defineProperty(this, "onClose", function () {});
  };

  var ageModal = new AgeModal();

  var Carousel = function Carousel(carousel) {
    _classCallCheck(this, Carousel);

    this.carousel = carousel;
    this.options = JSON.parse(this.carousel.getAttribute('data-flickity-config'));
    new Flickity(this.carousel, this.options);
  };

  document.querySelectorAll('.FeaturedCollection--carousel').forEach(function (carousel) {
    return new Carousel(carousel);
  });
  document.querySelectorAll('.ProductList--carousel').forEach(function (carousel) {
    return new Carousel(carousel);
  });

  (function () {
    var pNodes = new Set();
    document.querySelectorAll('p > img').forEach(function (img) {
      if (img.nextSibling && img.nextSibling.nodeName === 'IMG') {
        pNodes.add(img.parentNode);
      }
    });
    pNodes.forEach(function (pNode) {
      new FlickityImageGallery(pNode);
    });
  })();

  _toConsumableArray(document.links).forEach(function (link) {
    if (link.hostname !== window.location.hostname && link.target != "_self") {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  });

  document.querySelectorAll('.ProductItem__AddToCartOverlay').forEach(function (overlay) {
    var decreaseButton = overlay.querySelector('[data-action="decrease-quantity"]');
    var increaseButton = overlay.querySelector('[data-action="increase-quantity"]');
    var input = overlay.querySelector('.QuantitySelector__CurrentQuantity');
    var addToCartButton = overlay.querySelector('.ProductForm__AddToCart');
    decreaseButton.addEventListener('click', function () {
      input.value--;
    });
    increaseButton.addEventListener('click', function () {
      input.value++;
    });
    addToCartButton.addEventListener('click', function (event) {
      event.preventDefault();
      addToCartButton.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      $.post('/cart/add.js', $(overlay).serialize()).always(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        addToCartButton.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: overlay.querySelector('[name="id"]').value,
            quantity: parseInt(overlay.querySelector('[name="quantity"]').value)
          }
        }));
      });
      event.preventDefault();
    });
  });
  ageModal.init();
  /*if (ageModal.isOpen) {
    ageModal.onClose = szechenyiBar.init;
  } else {
    szechenyiBar.init();
  }*/

}());
